import AbstractRepository from "@/repositories/AbstractRepository";

export default class TypeRepository extends AbstractRepository {
    protected static resource: string = "ptf-request-type";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
        "code",
        "owner.uuid",
    ];
}
